export default __webpack_public_path__ + "mockup_entregas3.493f5d0.svg";